<template>
  <div class="rounded shadow bg-white mt-5 mb-6 flex justify-between overflow-hidden max-w-1200 lg:cursor-pointer " v-if="isCollegeCoach && videoCount > 0" @click="openEB">
    <i
        class="p-2 flex items-center text-white bg-indigo-300 rounded-default sr-2 sr-v2-eventbeacon-mark ds-text-3xl align-center middle"
    />
    <div class="m-3 flex items-start w-full hidden lg:inline-block">

      {{ videoCount }} {{ videoCount > 1 ? 'games' : 'game' }} available in EventBeacon On Demand. Watch {{ firstName }} play now!
    </div>
    <div class="my-2 mx-2 md:mx-3 ds-text-sm medium gray-900 lg:hidden w-full text-left ">Watch more about {{ firstName }} in
      action on EventBeacon On Demand.
      <div class="ds-text-xs normal gray-500 pt-1">
        <i class="sr-2 sr-v2-exclamation-circle ds-text-sm text-gray-500"></i> Available only on larger screens
      </div>
    </div>
    <span class="block mb-3 mt-3 hidden lg:inline-block lg:m-3"><i
        class="m-2 text-indigo-300 self-end sr-2 sr-v2-arrow-right"></i></span>

  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import track from "@/utils/segment";
import api from "@/services/api";
import pluralize from "pluralize";

export default {
  computed: {
    ...mapState({
      firstName: state => state.athleteProfile.user.firstName,
      studentId: state => state.athleteProfile.user.id,
      videoCount: state => state.athleteProfile.user.eventBeaconVideoCount,
    }),
    ...mapGetters({
      isCollegeCoach: "athleteProfile/isApplicableCollegeCoach",
    }),
  },
  methods: {
    pluralize(value, number) {
      return pluralize(value, number)
    },
    openEB() {
      if (['lg', 'xl'].includes(this.$mq)) {
        track('clicked_view_athlete_on_ebod', {
          action: 'click',
          athlete_viewed: window.location.href,
          cta_location: "video_section",
          cta_page: "athlete_profile",
          email: api.clientData('site_email'),
          site_access_id: api.clientData('site_access_id'),
        });
        window.open('/eb_on_demand/games?studentId=' + this.studentId, '_blank');
        return;
      }
    },
  }
}
</script>

<style lang="scss">
.max-w-1200 {
  max-width: 1200px;
}
</style>